<template>
    <div v-if="showCounter" class="countdownWrapper">
        <transition name="fade" mode="out-in">
            <p :key="foo[counter]" class="countdown">
                {{ foo[counter] }}
            </p>
        </transition>
    </div>

<!--    <div v-if="showCounter" class="countdownWrapper" style="position: absolute; z-index: 2; width:100%; height: 100%; left: 0; top: 0;">-->
<!--        <transition name="fade" mode="out-in">-->
<!--            <p :key="foo[counter]" class="countdown" style="font-size:3em; font-weight: bold; text-align:center; width:100%;">-->
<!--                {{ foo[counter] }}-->
<!--            </p>-->
<!--        </transition>-->
<!--    </div>-->
</template>

<script>
    export default {
        name: "Countdown",
        data: () => ({
            counter: 0,
            showCounter: false,
            foo: [3,2,1],
            timer: null,
            countdownTimer: null
        }),
        props: {
        },
        //$emit('onMediaClick', slide)
        methods:{
            startCountdown () {
                const self = this;
                this.counter = 0;
                this.showCounter = true;
                this.timer = setInterval(function () {
                    this.counter++;
                    if (this.counter >= this.foo.length) {
                        console.log('Snap');
                        clearInterval(self.timer);
                        self.showCounter = false;
                        self.$emit('on-countdown-finished');
                    }
                }.bind(this), 1000)
            },
        }
    }
</script>

<style>
.countdown {
  font-size: 6rem;
}
</style>